import React from 'react'
import summercollection from "../images/summer_collection Bethuadahari.jpg";
import weddingcollection from "../images/Wedding _Clothes.jpg";
import sareecollection from "../images/Saree_collection.jpg";


function Homeslide() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
         <div className='fashionbethua'>
      <img src={summercollection} className="d-block w-100" alt="summercollection_bethuadahari"/>
      </div>
    </div>
    <div className="carousel-item">
         <div className='fashionbethua'>
      <img src={weddingcollection} className="d-block w-100" alt="best garments in Bethauadahari"/>
      </div>
    </div>
    <div className="carousel-item">
         <div className='fashionbethua'>
      <img src={sareecollection} className="d-block w-100" alt="sareecollection"/>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Homeslide